<template>
    
</template>

<script>
    export default {
        name: "DeleteProduct"
    }
</script>

<style scoped>

</style>